import { TenantEntity } from '../TenantEntity'

export class DischargingTrucking extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'DischargingTrucking'
  }
  get arriveDateHour() {
    return this._data.arriveDateHour
  }
  set arriveDateHour(arriveDateHour) {
    this._data.arriveDateHour = arriveDateHour
  }
  get arriveDateMinutes() {
    return this._data.arriveDateMinutes
  }
  set arriveDateMinutes(arriveDateMinutes) {
    this._data.arriveDateMinutes = arriveDateMinutes
  }
  get truckingId() {
    return this._data.truckingId
  }
  set truckingId(truckingId) {
    this._data.truckingId = truckingId
  }
  get carryingCmp() {
    return this._data.carryingCmp
  }
  set carryingCmp(carryingCmp) {
    this._data.carryingCmp = carryingCmp || 0
  }
  get loadingDate() {
    return this._data.loadingDate
  }
  set loadingDate(loadingDate) {
    this._data.loadingDate = loadingDate
  }
  get driver() {
    return this._data.driver
  }
  set driver(driver) {
    this._data.driver = driver
  }
  get driverTel() {
    return this._data.driverTel
  }
  set driverTel(driverTel) {
    this._data.driverTel = driverTel
  }
  get driverName() {
    return this._data.driverName
  }
  set driverName(driverName) {
    this._data.driverName = driverName
  }
  get driverPhone() {
    return this._data.driverPhone
  }
  set driverPhone(driverPhone) {
    this._data.driverPhone = driverPhone
  }
  get doorName() {
    return this._data.doorName
  }
  set doorName(doorName) {
    this._data.doorName = doorName
  }
  get doorMan() {
    return this._data.doorMan
  }
  set doorMan(doorMan) {
    this._data.doorMan = doorMan
  }

  get zipCode() {
    return this._data.zipCode
  }
  set zipCode(zipCode) {
    this._data.zipCode = zipCode
  }
  get doorManTel() {
    return this._data.doorManTel
  }
  set doorManTel(doorManTel) {
    this._data.doorManTel = doorManTel
  }
  get doorAddr() {
    return this._data.doorAddr
  }
  set doorAddr(doorAddr) {
    this._data.doorAddr = doorAddr
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity || 0
  }
  get weight() {
    return this._data.weight
  }
  set weight(weight) {
    this._data.weight = weight || 0.0
  }
  get cubage() {
    return this._data.cubage
  }
  set cubage(cubage) {
    this._data.cubage = cubage || 0.0
  }
  get soNo() {
    return this._data.soNo
  }
  set soNo(soNo) {
    this._data.soNo = soNo
  }
  get truckOrderNo() {
    return this._data.truckOrderNo
  }
  set truckOrderNo(truckOrderNo) {
    this._data.truckOrderNo = truckOrderNo
  }
  get printState() {
    return this._data.printState
  }
  set printState(printState) {
    this._data.printState = printState || 0
  }
  get printDate() {
    return this._data.printDate
  }
  set printDate(printDate) {
    this._data.printDate = printDate
  }
  get printBy() {
    return this._data.printBy
  }
  set printBy(printBy) {
    this._data.printBy = printBy
  }
  get plateNumber() {
    return this._data.plateNumber
  }
  set plateNumber(plateNumber) {
    this._data.plateNumber = plateNumber
  }
  get truckingFee() {
    return this._data.truckingFee
  }
  set truckingFee(truckingFee) {
    this._data.truckingFee = truckingFee || 0.0
  }
  get destinationPortAdditionalFee() {
    return this._data.destinationPortAdditionalFee
  }
  set destinationPortAdditionalFee(destinationPortAdditionalFee) {
    this._data.destinationPortAdditionalFee = destinationPortAdditionalFee || ''
  }
  get sendState() {
    return this._data.sendState
  }
  set sendState(sendState) {
    this._data.sendState = sendState || 0
  }
  get interactiveNo() {
    return this._data.interactiveNo
  }
  set interactiveNo(interactiveNo) {
    this._data.interactiveNo = interactiveNo
  }
  get travelHour() {
    return this._data.travelHour
  }
  set travelHour(travelHour) {
    this._data.travelHour = travelHour || 0
  }
  get travelMinute() {
    return this._data.travelMinute
  }
  set travelMinute(travelMinute) {
    this._data.travelMinute = travelMinute || 0
  }
  get loadingPortService() {
    return this._data.loadingPortService
  }
  set loadingPortService(loadingPortService) {
    this._data.loadingPortService = loadingPortService || false
  }
  get dischargingPortService() {
    return this._data.dischargingPortService
  }
  set dischargingPortService(dischargingPortService) {
    this._data.dischargingPortService = dischargingPortService || false
  }
  get dischargingWay() {
    return this._data.dischargingWay
  }
  set dischargingWay(dischargingWay) {
    this._data.dischargingWay = dischargingWay
  }
  get po() {
    return this._data.po
  }
  set po(po) {
    this._data.po = po
  }
  get exChangeAgent() {
    return this._data.exChangeAgent
  }
  set exChangeAgent(exChangeAgent) {
    this._data.exChangeAgent = exChangeAgent || 0
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency
  }
  get serialNo() {
    return this._data.serialNo
  }
  set serialNo(serialNo) {
    this._data.serialNo = serialNo
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get containerUsages() {
    return this._data.containerUsages
  }
  set containerUsages(containerUsages) {
    this._data.containerUsages = containerUsages
  }
  get relatedTrucking() {
    return this._data.relatedTrucking
  }
  set relatedTrucking(relatedTrucking) {
    this._data.relatedTrucking = relatedTrucking
  }
  get boxesNumber() {
    return this._data.boxesNumber
  }
  set boxesNumber(boxesNumber) {
    this._data.boxesNumber = boxesNumber
  }
  get carFormUuid() {
    return this._data.carFormUuid
  }
  set carFormUuid(carFormUuid) {
    this._data.carFormUuid = carFormUuid
  }
  get palletDetail() {
    return this._data.palletDetail
  }
  set palletDetail(palletDetail) {
    this._data.palletDetail = palletDetail
  }
  get palletSize() {
    return this._data.palletSize
  }
  set palletSize(palletSize) {
    this._data.palletSize = palletSize
  }
}
